remitRegisterModule.factory('RemitAccessTypes', function(){
    return {
        AllowRemitContract : "AllowRemitContract",
        AllowRemittance : "AllowRemittance",
        AllowVoid : "AllowVoid",
        AllowConfirm : "AllowConfirm"
    };
});
